<template>
  <v-btn icon @click="setTheme">
    <v-icon>mdi-invert-colors</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "ThemeSwitch",
  data: () => ({}),
  methods: {
    setTheme() {
      if (this.$vuetify.theme.dark) {
        localStorage.setItem("theme", "false");
        return (this.$vuetify.theme.dark = false);
      } else {
        localStorage.setItem("theme", "true");
        return (this.$vuetify.theme.dark = true);
      }
    },
    getTheme() {
      //dark on first
      if (!localStorage.getItem("theme")) {
        localStorage.setItem("theme", "false");
        return (this.$vuetify.theme.dark = false);
      }
      //remember selected theme
      this.$vuetify.theme.dark = JSON.parse(localStorage.getItem("theme"));
    },
  },
  created() {
    this.getTheme();
  }
}
</script>

<style scoped>

</style>
